import LogList from '@/components/log/list/LogList.vue'
import TableFilter from '@/components/common/tablefilter/TableFilter.vue'

const defaultFilterValues = {
  logtype: 'CONF',
  materials: [],
  type: null,
  client: null
};
export default {
  name: 'MaterialLog',
  components: {
    LogList,
    TableFilter
  },
  data () {
    return {
      isMounted: false,
      filterValues: {
        logtype: 'CONF',
        materials: [],
        type: null,
        isGlobalConfig: [],
        client: null,
        date: null,
        datefrom: null,
        dateto: null,
        user: null
      }
    }
  },
  computed: {
    logReqPath () {
      return 'material/log';
    },
    logItemName () {
      if (this.filterValues.logtype === 'RATE') {
        return 'materialrates';
      }
      return 'materials';
    },
    logTitle () {
      return '';
    },
    logtypeOptions () {
      return [
        { code: 'CONF', text: this.$t('log.filters.materials.CONF') },
        { code: 'RATE', text: this.$t('log.filters.materials.RATE') }
      ]
    },
    materialOptions () {
      return this.$store.getters.getConfigOptions('materials', this.$i18n.locale)
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    logRecordTypeOptions () {
      let options = this.$store.getters.getConfigOptions('log_record_types', this.$i18n.locale);
      let allowedCodes = ['MAT-CH', 'MAT-DEL', 'MAT-REN', 'MAT-CAT-CH', 'MAT-CAT-DEL', 'MAT-CAT-REN', 'MAT-GR-CH', 'MAT-GR-DEL', 'MAT-GR-REN'];
      if (this.filterValues.logtype === 'RATE') {
        allowedCodes = ['MAT-GEN-NEW', 'MAT-GEN-CH', 'MAT-GEN-DEF'];
      }
      options = options.filter(el => allowedCodes.includes(el.code));
      options.unshift({ code: null, text: '' });
      return options;
    },
    tableFilterConfig () {
      const filters = {};
      filters.logtype = { type: 'select', label: this.$t('log.filters.title'), options: this.logtypeOptions };
      filters.type = { type: 'select', label: this.$t('log.filters.type'), options: this.logRecordTypeOptions, colOnlyFilter: true };
      filters.date = { type: 'date', label: this.$t('general.filters.datefrom'), colOnlyFilter: true, short: true };
      filters.datefrom = { type: 'date', label: this.$t('general.filters.datefrom') };
      filters.dateto = { type: 'date', label: this.$t('general.filters.dateto') };
      filters.materials = { type: 'searchchecklist', label: '', elname: 'material', nameParam: 'text', keyParam: 'code', options: this.materialOptions, class: 'col-sm-12' };
      filters.user = { type: 'userpicker', label: this.$t('log.user'), colOnlyFilter: true };
      if (this.filterValues.logtype === 'RATE') {
        filters.isGlobalConfig = { type: 'checkbox', label: this.$t('log.filters.materials.isGlobalConfig'), options: this.yesNoOptions };
        filters.client = { type: 'clientpicker', label: '' };
      }
      return filters;
    }
  },
  methods: {
    filterChanged (key, val) {
      this.filterValues[key] = val;
      if (key === 'logtype') {
        this.filterValues.types = [];
      }
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.loadLog();
    },
    loadLog () {
      this.$refs.logList.changePage(1);
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
  }
}
